import {Component, OnDestroy, OnInit} from '@angular/core';
import {Config} from "../../environments/environment";

declare var $:any;

/**
 * This class represents the lazy loaded AboutComponent.
 */
@Component({
    selector: 'sd-about',
    templateUrl: 'about.component.html',
    styleUrls: ['about.component.css'],
    providers: [],
    standalone: false
})
export class AboutComponent implements OnInit, OnDestroy{

  appName:string;

  constructor(){
    this.appName = Config.TITLE;
  }

  ngOnInit(){

    $("#version").load("../version.txt");
    //$("#licenses").load("../../resources/license-frontend.txt");

    $.get( "../../resources/license-backend.txt", function(data:any) {
      $("#licenses").append("<p style='font-family: Arial;'>" + data + "</p>");
    });
    $.get( "../../resources/license-frontend.txt", function(data:any) {
      $("#licenses").append("<p style='font-family: Arial; white-space: pre'>" + data + "</p>");
    });

  }

  ngOnDestroy(){
    $('.modal-backdrop').remove();
  }
}
